import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-data-modules',
  templateUrl: './data-modules.component.html',
  styleUrls: ['./data-modules.component.scss']
})
export class DataModulesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
